import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'applicantStatusPipe'
})
export class ApplicantStatusPipe implements PipeTransform {

  private listObj = {
    0: 'Pending',
    1: 'Accepted',
    2: 'Rejected',
    3: 'Cancelled',
  };

  transform(value: number): string {
    console.log("transforming: ", value)
    return this.listObj.hasOwnProperty(value) ? this.listObj[value] : '';
  }

}
